export const CONFIG_NAMESPACE                 = 'vocento.config.vam';
export const EDITIONS_NAMESPACE               = 'vocento.site.editions';
export const GPT_ID_VOCENTO                   = '4900';
export const GPT_READY                        = 'vam:gpt:ready';
export const GPT_TIMEOUT                      = 2000;
export const TIMEOUT_POSICIONES_ESTANDAR      = 3000;
export const AMAZONADS_ID_VOCENTO             = '3470';
export const AMAZONADS_READY                  = 'vam:amazonads:ready';
export const AMAZONADS_TIMEOUT_ERROR_CARGA_JS = 7000;
export const ALTOS_MINIMOS_DISPOSITIVOS       = {
                                                "mobile": 0,
                                                "tablet": 200,
                                                "desktop": 300
                                              };
export const POSITION_FLUID                   = "'fluid'";
export const SLOT_RENDERED                    = 'vam:slotrendered';
export const SLOT_EMPTY                       = 'vam:isempty';
export const SLOT_VIEWABLE                    = 'vam:viewable';
export const SLOT_INACTIVE                    = 'vam:inactive';
export const DEFAULTS                         = {
                                                hideNoAds:  true,
                                                refresh:    false,
                                                responsive: false
                                              };
export const CAPTURADOR_WS                    = 'http://publi.cmvocento.com/capturador/preview';
export const RIJNDAEL_URL                     = '//netssl.vocento.com/cmvocento/js/rijndael.js';
export const MCRYPT_URL                       = '//netssl.vocento.com/cmvocento/js/mcrypt.js';
export const MCRYPT_KEY                       = 'acsNdl09acs72AEdacsNdl09acs72AEd';
export const VAM_CSS_URL                      = '//netssl.vocento.com/cmvocento/css/vam.css';
export const JSON_GDP2_0                      = 0;
export const JSON_GDP2_1                      = 1;
export const JSON_GDP2_2                      = 2;
export const NOMBRE_FORMATO_JSON              = ['GDP2.0', 'GDP2.1', 'GDP2.2+'];



// WEBPACK FOOTER //
// ./src/constants.js